import dictionaries from '../../translations/dictionary';

const parseLanguageFromUrl = () : string | null => {
  const { href } = window.location;
  const { searchParams } = new URL(href);
  const lang = searchParams.getAll('lang');

  return lang.length > 0 ? lang.slice(-1)[0].toLowerCase() : null;
};

const getKnownLanguages = (toAppend: string = 'en') => {
  const nonNullable = <T>(value: T): value is NonNullable<T> => {
    return value !== null && value !== undefined;
  };

  const languages: Array<string | null> = [
    parseLanguageFromUrl(),
    window.navigator.language,
    ...(window.navigator.languages || []),
    toAppend,
  ];

  return languages
    .filter(nonNullable)
    .map((language) => language.substring(0, 2))
    .filter(
      (language, position, array) =>
        dictionaries[language] && position === array.indexOf(language),
    );
};


export { getKnownLanguages };
